var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.5 39.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "custom_dnb_calendar_svg__cls-1",
    d: "M9.8 15a.75.75 0 000 1.5zm19.9 1.5a.75.75 0 000-1.5zM5.27 5.92a.75.75 0 000-1.5zM.75 5.17v-.75a.75.75 0 00-.75.75zm0 33.58H0a.76.76 0 00.75.75zm38 0v.75a.76.76 0 00.75-.75zm0-33.58h.75a.75.75 0 00-.75-.75zm-4.52-.75a.75.75 0 000 1.5zm-19.91 0a.75.75 0 000 1.5zm10.86 1.5a.75.75 0 000-1.5zM10.55.75a.75.75 0 00-1.5 0zm-1.5 8.84a.75.75 0 001.5 0zM30.45.75a.75.75 0 00-1.5 0zM29 9.59a.75.75 0 001.5 0zM9.8 16.52h19.9V15H9.8zM5.27 4.42H.75v1.5h4.52zM0 5.17v33.58h1.5V5.17zM.75 39.5h38V38h-38zm38.75-.75V5.17H38v33.58zm-.75-34.33h-4.52v1.5h4.52zm-24.43 1.5h10.86v-1.5H14.32zM9.05.75v8.84h1.5V.75zM29 .75v8.84h1.5V.75z",
    "data-name": "Layer 1"
  }))));
}

export default SvgCustomDnbCalendar;